/* eslint-disable indent */
/* eslint-disable func-style */
import { copyObject } from '../';
import CookieHelper from '../../utils/Apply/ApplyCookieHelper';
import {Message} from './message';
import root from 'window-or-global';

//Don't change this object.
export const POST_AD_FIELDS = {
  TITLE: 'title',
  DESCRIPTION: 'description',
  TYPE: 'jobType',
  ROLE: 'role',
  SUB_ROLE: 'subRole',
  ROLE_SUB_ROLE: 'roleSubrole',
  MIN_SALARY: 'minSalary',
  MAX_SALARY: 'maxSalary',
  MIN_EXPERIENCE: 'minExp',
  MAX_EXPERIENCE: 'maxExp',
  RECRUITER_EMAIL: 'recruiterEmail',
  RECRUITER_PHONE: 'recruiterMobile',
  CITY: 'city',
  LOCALITY: 'locality',
  HIRING_COMPANY: 'hiringCompany',
  POSTED_BY_COMPANY: 'postedByCompany',
  CITY_LOCALITY: 'cityLocality',
  DISPLAY_CONTACT: 'displayContact',
  INCLUDE_WEBSITE_URL: 'includeWebsiteUrl',
  INCLUDE_MOBILE_NUMBER: 'includeMobileNumber',
  QUIKR_RECRUITMENT_SERVICES: 'quikrRecruitmentServices',
  REMOTE_JOB: 'remoteJob',
  CUSTOM_ERROR_FIELD: 'customErrorField',
  PACK_SELECTION: 'packSelection'
};

export const FORM_ELEMENTS = {
  JOB_AD: 'jobAd',
  PAYMENT_CART: 'jobCart'
};

export const POST_AD_FORMS = {
  POST_AD_STEP_1: 'POST_AD_STEP_1',
  POST_AD_STEP_2: 'POST_AD_STEP_2',
  EDIT_AD_STEP_1: 'EDIT_AD_STEP_1',
  EDIT_AD_STEP_2: 'EDIT_AD_STEP_2'
};

export const PAP_ERROR_MESSAGES = {
  ERROR: 'Something went wrong. Please try again',
  MAX_FREE_POSTED: 'You have posted maximum free ads in last 24 hours. You can post Gold jobs now',
  MAX_FREE_ACTIVE_AD_POSTED: 'Your limit of a maximum of [[MAX_LIMIT]] active free ads for city [[CITY_NAME]] is exceeded',
  MAX_GLOBAL_ACTIVE_AD_POSTED: 'You have reached your Monthly limit of [[MAX_LIMIT]] free active ads',
  MAX_TOTAL_AD_POSTED: 'Your total free ad limit of jobs post is exceeded.'
};

export const PAP_CONSTANTS = {
  FULL_CITY: 'Full City',
  MAX_FREE_LOCALITY: 5,
  TITLE_MIN_CHARACTER: 10,
  DEFAULT_MAX_SALARY: 100000,
  TECH_MAX_SALARY: 500000
};

export const defaultJobsPostAdRequestState = {
  [POST_AD_FIELDS.TYPE]: {
    show: true,
    disabled: false,
    options: [
    ],
    selectedId: 272,
    value: 'Full Time Jobs'
  },
  [POST_AD_FIELDS.MIN_SALARY]: {
    show: true,
    value: '',
    message: (new Message(1, 0, '', { field: POST_AD_FIELDS.MIN_SALARY })).get(),
  },
  [POST_AD_FIELDS.MAX_SALARY]: {
    show: true,
    value: '',
    message: (new Message(1, 0, '', { field: POST_AD_FIELDS.MAX_SALARY })).get(),
  },
  [POST_AD_FIELDS.TITLE]: {
    value: '',
    show: true,
    disabled: false,
    message: (new Message(1,0, '', { field: POST_AD_FIELDS.TITLE })).get()
  },
  [POST_AD_FIELDS.HIRING_COMPANY]: {
    value: '',
    disabled: false,
    show: true,
    message: (new Message(1,0, '', { field: [POST_AD_FIELDS.HIRING_COMPANY] })).get()
  },
  [POST_AD_FIELDS.POSTED_BY_COMPANY]: {
    value: '',
    disabled: true,
    show: false,
    message: (new Message(1,0, '', { field: [POST_AD_FIELDS.POSTED_BY_COMPANY] })).get()
  },
  [POST_AD_FIELDS.CITY]: {
    value: '',
    id: '',
    apiUrl: '/jobs/jobsAjax/getAllCities',
    message: (new Message(1, 0, '', { field: POST_AD_FIELDS.CITY })).get(),
  },
  [POST_AD_FIELDS.LOCALITY]: {
    apiUrl: '/jobs/jobsAjax/localitySearch?cityName=',
    value: [],
    disabled: true,
    show: true,
    maxLimit: 5,
    fullCity : {
      display: '',
      show: false
    },
    message: (new Message(1, 0, '', { field: POST_AD_FIELDS.LOCALITY })).get(),
  },
  [POST_AD_FIELDS.ROLE]: {
    // value: '',
    // id: -1,
    valueObject: {},
    message: (new Message(1, 0, '', { field: POST_AD_FIELDS.ROLE })).get(),
    others: ''
  },
  [POST_AD_FIELDS.SUB_ROLE]: {
    valueObject: []
  },
  [POST_AD_FIELDS.MIN_EXPERIENCE]: {
    value: '',
    options: [],
    defaultOptions: [],
    message: (new Message(1, 0, '', { field: POST_AD_FIELDS.MIN_EXPERIENCE })).get(),
  },
  [POST_AD_FIELDS.MAX_EXPERIENCE]: {
    value: '',
    options: [],
    defaultOptions: [],
    message: (new Message(1, 0, '', { field: POST_AD_FIELDS.MAX_EXPERIENCE })).get(),
  },
  [POST_AD_FIELDS.DESCRIPTION]: {
    value: '',
    message: (new Message(1, 0, '', { field: POST_AD_FIELDS.DESCRIPTION })).get()
  },
  [POST_AD_FIELDS.RECRUITER_EMAIL]: {
    value: '',
    message: (new Message(1, 0, '', { field: POST_AD_FIELDS.RECRUITER_EMAIL })).get(),
    options: [],
    label: 'Email'
  },
  [POST_AD_FIELDS.RECRUITER_PHONE]: {
    value: '',
    message: (new Message(1, 0, '', { field: POST_AD_FIELDS.RECRUITER_PHONE })).get(),
    options: [],
    label: 'Phone'
  },
  [POST_AD_FIELDS.DISPLAY_CONTACT]: {
    checked: true
  },
  [POST_AD_FIELDS.INCLUDE_WEBSITE_URL]: {
    checked: false,
    url: '',
    message: (new Message(1, 0, '', { field: POST_AD_FIELDS.INCLUDE_WEBSITE_URL })).get()
  },
  [POST_AD_FIELDS.INCLUDE_MOBILE_NUMBER]: {
    checked: false
  },
  [POST_AD_FIELDS.QUIKR_RECRUITMENT_SERVICES]: {
    value: '',
    message: (new Message(1, 0, '', { field: POST_AD_FIELDS.QUIKR_RECRUITMENT_SERVICES })).get()
  },
  [POST_AD_FIELDS.REMOTE_JOB]: {
    value: '',
    message: (new Message(1, 0, '', { field: POST_AD_FIELDS.REMOTE_JOB })).get()
  },
  others: {
    formType: POST_AD_FORMS.POST_AD_STEP_1,
    paymentTotal: {
      value: 0,
      type: 'money'
    },
    packContainerMessage: null,
    selectedPack: 'freeAd',
    selectedSubPack: null,
    message: '',
    customErrorField: '' // used for displaying validation message ref: formchangehandler@handleSubmit
  },
  showLoader: false,
  showUnlimitedFreeAdsBanner: false,
  showOTP: false,
  packContainerVersion: 1,
  step: 1,
  validationVersion: 0,
  currentStep: 0  // this step is to notify what fields to show the user currently
};

export const updateCityField = (existingCityObject, cityName, cityId) => {
  let updatedCityObject = copyObject(existingCityObject);
  updatedCityObject.value = cityName;
  updatedCityObject.id = cityId;
  return updatedCityObject;
};

export const updateLocalityFieldWithCity = (existingLocalityObject, cityName) => {
  let updatedLocalityObject = copyObject(existingLocalityObject);
  if (existingLocalityObject.show) {
    updatedLocalityObject.disabled = false;
  }
  updatedLocalityObject.value = [];
  updatedLocalityObject.apiUrl = '/jobs/jobsAjax/localitySearch?cityName=' + cityName;
  return updatedLocalityObject;
};

export const updateSubRolesFieldWithRole = (existingSubRoleObject, roleObject) => {
  let updatedSubRoleObject = copyObject(existingSubRoleObject);
  if (existingSubRoleObject.show) {
    updatedSubRoleObject.disabled = false;
  }
  updatedSubRoleObject.value = [];
  updatedSubRoleObject.subList = roleObject.subList;
  return updatedSubRoleObject;
};

export const showOnlyFreeJobsPostingVersion =() => {
    let config = typeof root.JobSnow != 'undefined' && root.JobSnow.upgradeAdAbRand ? parseInt(root.JobSnow.upgradeAdAbRand, 10) : 0;
    let cookieHelper = new CookieHelper();
    let abRandMobile = cookieHelper.getABRandMobile();
    return abRandMobile <= config;
};




// WEBPACK FOOTER //
// ../q-jobs/src/utils/JobsPostAd/index.js